const map = {
	"./data-accounts-dark.svg": [
		8174,
		[
			174
		]
	],
	"./data-accounts-light.svg": [
		7182,
		[
			182
		]
	],
	"./data-assets-dark.svg": [
		1759,
		[
			759
		]
	],
	"./data-assets-light.svg": [
		3149,
		[
			149
		]
	],
	"./data-calls-dark.svg": [
		3125,
		[
			125
		]
	],
	"./data-calls-light.svg": [
		2595,
		[
			595
		]
	],
	"./data-destroyed_assets-dark.svg": [
		163,
		[
			163
		]
	],
	"./data-destroyed_assets-light.svg": [
		8457,
		[
			457
		]
	],
	"./data-destroyed_foreign_assets-dark.svg": [
		6474,
		[
			474
		]
	],
	"./data-destroyed_foreign_assets-light.svg": [
		2658,
		[
			658
		]
	],
	"./data-destroyed_nft-dark.svg": [
		3664,
		[
			283
		]
	],
	"./data-destroyed_nft-light.svg": [
		8384,
		[
			384
		]
	],
	"./data-events-dark.svg": [
		9419,
		[
			419
		]
	],
	"./data-events-light.svg": [
		2577,
		[
			577
		]
	],
	"./data-extrinsics-dark.svg": [
		5371,
		[
			752
		]
	],
	"./data-extrinsics-light.svg": [
		2296,
		[
			296
		]
	],
	"./data-foreign_assets-dark.svg": [
		8806,
		[
			806
		]
	],
	"./data-foreign_assets-light.svg": [
		7926,
		[
			926
		]
	],
	"./data-identities-dark.svg": [
		7696,
		[
			696
		]
	],
	"./data-identities-light.svg": [
		1283,
		[
			664
		]
	],
	"./data-identity_judgements-dark.svg": [
		187,
		[
			187
		]
	],
	"./data-identity_judgements-light.svg": [
		8065,
		[
			65
		]
	],
	"./data-identity_registrars-dark.svg": [
		5319,
		[
			319
		]
	],
	"./data-identity_registrars-light.svg": [
		7205,
		[
			205
		]
	],
	"./data-multisig_accounts-dark.svg": [
		5607,
		[
			607
		]
	],
	"./data-multisig_accounts-light.svg": [
		3333,
		[
			333
		]
	],
	"./data-multisigs-dark.svg": [
		6243,
		[
			243
		]
	],
	"./data-multisigs-light.svg": [
		7849,
		[
			849
		]
	],
	"./data-nft-dark.svg": [
		364,
		[
			364
		]
	],
	"./data-nft-light.svg": [
		2820,
		[
			820
		]
	],
	"./data-proxy-dark.svg": [
		1460,
		[
			460
		]
	],
	"./data-proxy-light.svg": [
		1324,
		[
			324
		]
	],
	"./data-recoverables-dark.svg": [
		4299,
		[
			299
		]
	],
	"./data-recoverables-light.svg": [
		7777,
		[
			777
		]
	],
	"./data-recoveries-dark.svg": [
		3289,
		[
			289
		]
	],
	"./data-recoveries-light.svg": [
		5215,
		[
			215
		]
	],
	"./data-recovery_proxies-dark.svg": [
		1282,
		[
			282
		]
	],
	"./data-recovery_proxies-light.svg": [
		4602,
		[
			602
		]
	],
	"./data-transfers-dark.svg": [
		8752,
		[
			371
		]
	],
	"./data-transfers-light.svg": [
		5744,
		[
			744
		]
	],
	"./data-vestings-dark.svg": [
		1593,
		[
			593
		]
	],
	"./data-vestings-light.svg": [
		3983,
		[
			983
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9092;
module.exports = webpackAsyncContext;